var $d82900cf6117761a$exports = {};
$d82900cf6117761a$exports = {
    "help": `N\xe1pov\u{11B}da`,
    "info": `Informace`
};


export {$d82900cf6117761a$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
